<template>
  <div class="product-items" data-testid="product-card">
    <div class="relative">
      <SfLink class="product-link" :tag="NuxtLink" :to="`${paths.product}${slug}`">
        <NuxtImg
          :src="imageUrl"
          :alt="imageAlt"
          class="product-image"
          data-testid="image-slot"
          width="442"
          height="312"
          :loading="lazy && !priority ? 'lazy' : undefined"
          :fetchpriority="priority ? 'high' : undefined"
          :preload="priority"
          format="webp"
        />
      </SfLink>
    </div>
    <div class="product-info">
      <div class="product-thumbnail" v-if="gallery && gallery.length > 0">
        <div class="thumbs" v-for="(item, index) in gallery" :key="index">
          <img :src="item.url"/>
        </div>
      </div>
      <SfLink :tag="NuxtLink" :to="`${paths.product}${slug}`" class="product-name" variant="secondary">
        {{ name }}
      </SfLink>
      <div class="product-description" v-html="description"></div>
      <span class="product-price" data-testid="product-card-vertical-price">
        {{ usePrice(price) }}
      </span>
<!--      <SfButton size="sm">-->
<!--        <template #prefix>-->
<!--          <SfIconShoppingCart size="sm" />-->
<!--        </template>-->
<!--        {{ $t('addToCartShort') }}-->
<!--      </SfButton>-->
    </div>
  </div>
</template>

<script setup lang="ts">
import { SfLink, SfRating, SfCounter, SfButton, SfIconShoppingCart } from '@storefront-ui/vue';
import type { ProductCardProps } from '~/components/ui/ProductCard/types';

withDefaults(defineProps<ProductCardProps>(), {
  lazy: true,
  imageAlt: '',
});

const NuxtLink = resolveComponent('NuxtLink');
</script>
